import { render, staticRenderFns } from "./InstructionsRemittance.vue?vue&type=template&id=1fcfbff8&scoped=true"
import script from "./InstructionsRemittance.vue?vue&type=script&lang=ts"
export * from "./InstructionsRemittance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcfbff8",
  null
  
)

export default component.exports